// @license Copyright (c) 2016 Copyright Holder All Rights Reserved.
(function() {
	"use strict";

	angular
		.module("swurveys.maker", [
			"swurveys.common",
			"angularModalService",
			"color.picker",
			"dndLists",
			"ui.slider",
	    "ngSanitize",
	    "ngRoute",
	    "ngCookies",
	    "ngAnimate",
	    "720kb.socialshare",
	    "chart.js",
			"ng.jsoneditor",
			"templates"
		])
		.config(config)
		.run(run);

	function config($routeProvider, $locationProvider, $httpProvider) {
		var resolveUser = function(authService) {
			return authService.async();
		};

		resolveUser.$inject = ["authService"];

		$routeProvider
			.when("/e/:sid/:advanced?", {
				templateUrl: "app/maker/states/editor/editor.html",
				controller: "editorController",
				resolve: {
					"loggedInUser": resolveUser
				}
			})
			.when("/a/:sid/:dataType?", {
				templateUrl: function(params){
					console.log("params", params);
					var template = "app/maker/states/analytics/analytics.html";
					if(params.dataType == "billboard")
					{
						template = "app/maker/states/analytics/billboard.html";
					}
					return  template;
				},
				controller: "analyticsController",
				resolve: {
					"loggedInUser": resolveUser
				}
			})
			.when("/l", {
				templateUrl: function() {return "app/maker/states/login/login.html";},
				controller: "loginController as login",
				params: {
					message: null
				},
				resolve: {
					"loggedInUser": resolveUser
				}
			})
			.when("/d/:uid", {
				templateUrl: "app/maker/states/dashboard/dashboard.html",
				controller: "dashboardController as dash",
				resolve: {
					"loggedInUser": resolveUser
				}
			})
			.when("/admin", {
				templateUrl: "app/maker/states/admin/admin.html",
				controller: "adminController as admin",
				resolve: {
					"loggedInUser": resolveUser
				}
			})
			.when("/admin/wall", {
				templateUrl: "app/maker/states/admin/adminWall.html",
				controller: "adminWallController as adminWall",
				resolve: {
					"loggedInUser": resolveUser
				}
			})
			.when("/error", {
				templateUrl: "app/maker/states/error/error.html",
				controller: "errorController as error"
			})
			.when("/optout", {
				templateUrl: "app/maker/states/optout/optout.html",
				controller: "optoutController as optout"
			})
			.otherwise({
				redirectTo: "/l"
			});

		$locationProvider.html5Mode({
			enabled: false,
			requireBase: true
		});

		//initialize get if not there
		if (!$httpProvider.defaults.headers.get) {
			$httpProvider.defaults.headers.get = {};
		}

	}

	function run($rootScope, $location, analyticsService, clipboardService) {
		clipboardService.init();

		$rootScope.$on("$routeChangeSuccess", function(event, next, current) {
			analyticsService.trackPage($location.path());
		});
	}

	function installServiceWorker() {
		if ('serviceWorker' in navigator) {
			window.addEventListener('load', function() {
				navigator.serviceWorker.register('/sw.js').then(function(registration) {
					// Registration was successful
					console.log('ServiceWorker registration successful with scope: ', registration.scope);
				}).catch(function(err) {
					// registration failed :(
					console.log('ServiceWorker registration failed: ', err);
				});
			});
		}
	}
	installServiceWorker();


}());
